import { render, staticRenderFns } from "./PlateStockPopularTable.vue?vue&type=template&id=30e99e01&scoped=true"
import script from "./PlateStockPopularTable.vue?vue&type=script&lang=js"
export * from "./PlateStockPopularTable.vue?vue&type=script&lang=js"
import style0 from "./PlateStockPopularTable.vue?vue&type=style&index=0&id=30e99e01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e99e01",
  null
  
)

export default component.exports